import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];

    if (!sessionId) {
      setError("Missing session_id");
      setTimeout(() => navigate("/login", { replace: true }), 1200);
      return;
    }

    (async () => {
      try {
        await loginWithGoogleSession(sessionId);
        // Clean the URL fragment, then go to dashboard
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Google sign-in failed");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    })();
  }, [loginWithGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F7FA]" data-testid="auth-callback-page">
      <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm flex flex-col items-center gap-4 max-w-sm w-full mx-4">
        <Logo />
        {error ? (
          <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-3 py-2 font-mono text-center" data-testid="auth-callback-error">
            {error}
          </div>
        ) : (
          <>
            <Loader2 className="animate-spin text-[#003366]" size={28} />
            <div className="text-sm text-slate-600">Completando inicio de sesión con Google…</div>
          </>
        )}
      </div>
    </div>
  );
}
